import { useState, useEffect } from "react";
import {
  Box,
  Button,
  Divider,
  TextField,
  Typography,
  Dialog,
  DialogContent,
  IconButton,
} from "@mui/material";
import { UseProductGifts } from "./UseProductGifts";
import SearchComGift from "./SearchComGift";
import { useRecoilState } from "recoil";
import { rsProgress } from "../../../RecoilStates";
import BrandSearchCom from "../../../basic-information/brand/BrandSearchCom";
import SelectGroup from "../../../ContentManagement/firstPage/HomeOffer/SelectGroup";
import { useSnackbar } from "notistack";
import { toMoney, removeComma } from "../../../util/Utils";
import ClearIcon from "@mui/icons-material/Clear";
import GiftSearchCom from "./GiftSearchCom";
import FiberManualRecordIcon from "@mui/icons-material/FiberManualRecord";
import useBreakpoints from "../../../hooks/useBreakpoints";

export default function AddProductGift(props) {
  const { enqueueSnackbar } = useSnackbar();
  const {
    addProductgifts,
    deleteProductgifts,
    getFilterCount,
    getProductByID,
  } = UseProductGifts();
  const [name, setName] = useState("");
  const [openGift, setOpenGift] = useState(false);
  const [filterCount, setFilterCount] = useState();
  const [giftName, setGiftName] = useState("");
  const [state, setState] = useState({
    productID: undefined,
    brandID: undefined,
    groupID: undefined,
    minCost: 0,
    maxCost: 0,
    giftID: undefined,
  });
  const { isSmall } = useBreakpoints();

  useEffect(() => {
    if (openGift) {
      let newBody = Object.fromEntries(
        Object.entries(state).filter(([_, v]) => v != undefined)
      );
      getFilterCount(newBody, (callback) => {
        setFilterCount(callback);
      });
    }
  }, [openGift]);

  return (
    <Box>
      <Dialog
        open={openGift}
        maxWidth="sm"
        fullWidth
        onClose={() => {
          setState({
            ...state,
            giftID: undefined,
          });
          setGiftName("");
          setOpenGift(false);
        }}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogContent sx={{}}>
          <Box
            sx={{
              width: "100%",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <Typography color="secondary" variant="subtitle2">
              {filterCount} مورد یافت شد
            </Typography>
            <IconButton
              onClick={() => {
                setState({
                  ...state,
                  giftID: undefined,
                });
                setGiftName("");
                setOpenGift(false);
              }}
            >
              <ClearIcon fontSize="small" />
            </IconButton>
          </Box>

          <Divider sx={{ mb: 1 }} />
          <Box>
            <Typography variant="subtitle2">
              لطفا کد هدیه مورد نظر را وارد کنید
            </Typography>
            <Box
              sx={{
                width: "100%",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
              }}
            >
              <GiftSearchCom
                productID={state.giftID}
                productModel={state}
                setProductModel={setState}
              />
              <Box sx={{ mt: 2 }}>
                <Button
                  onClick={() => {
                    if (!state.giftID) {
                      enqueueSnackbar("لطفا کد هدیه را وارد کنید", {
                        variant: "error",
                        autoHideDuration: 2000,
                      });
                      return;
                    }
                    addProductgifts(state, () => {
                      setGiftName("");
                      setOpenGift(false);
                      setState({
                        productID: undefined,
                        brandID: undefined,
                        groupID: undefined,
                        minCost: undefined,
                        maxCost: undefined,
                        giftID: undefined,
                      });
                      props.callback();
                    });
                  }}
                  sx={{ mr: 2 }}
                  color="secondary"
                  variant="contained"
                >
                  افزون
                </Button>
                <Button
                  onClick={() => {
                    let model = {
                      productID: state.productID ? state.productID : undefined,
                      brandID: state.brandID ? state.brandID : undefined,
                      groupID: state.groupID ? state.groupID : undefined,
                      minCost: state.minCost ? state.minCost : 0,
                      maxCost: state.maxCost ? state.maxCost : 0,
                      giftID: 0,
                    };

                    deleteProductgifts(model, () => {
                      setOpenGift(false);
                      setGiftName("");
                      setState({
                        productID: undefined,
                        brandID: undefined,
                        groupID: undefined,
                        minCost: undefined,
                        maxCost: undefined,
                        giftID: undefined,
                      });
                      props.callback();
                    });
                  }}
                  color="secondary"
                  variant="outlined"
                >
                  حذف
                </Button>
              </Box>
            </Box>
          </Box>
        </DialogContent>
      </Dialog>
      <Box sx={{ mb: 2, display: "flex", alignItems: "center", gap: 0.5 }}>
        <FiberManualRecordIcon color="secondary" fontSize="small" />
        <Typography color="secondary" variant="subtitle1">
          براساس محصول
        </Typography>
      </Box>
      <Box display="grid" gridTemplateColumns="repeat(12, 1fr)" gap={2}>
        <Box gridColumn={isSmall ? "span 12" : "span 9"}>
          <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
            <SearchComGift
              productID={state.productID}
              productModel={state}
              setProductModel={setState}
            />

            <Button
              sx={{ width: "70px" }}
              variant="contained"
              disabled={!state.productID ? true : false}
              onClick={() => {
                setOpenGift(true);
              }}
            >
              عملیات
            </Button>
          </Box>
        </Box>
      </Box>
      <Box
        sx={{ mt: 4, mb: 2, display: "flex", alignItems: "center", gap: 0.5 }}
      >
        <FiberManualRecordIcon color="secondary" fontSize="small" />
        <Typography color="secondary" variant="subtitle1">
          براساس برند
        </Typography>
      </Box>
      <Box display="grid" gridTemplateColumns="repeat(12, 1fr)" gap={2}>
        <Box gridColumn={isSmall ? "span 12" : "span 4"}>
          <BrandSearchCom
            setName={setName}
            selectedBrandID={state.brandID}
            setter={setState}
            lvl1State={state}
          ></BrandSearchCom>
        </Box>
        <Box
          sx={{ display: "flex", alignItems: "center", gap: 2 }}
          gridColumn={isSmall ? "span 12" : "span 8"}
        >
          <TextField
            sx={{
              width: isSmall ? "40%" : "25%",
              input: {
                textAlign: "center",
              },
            }}
            disabled={!state.brandID ? true : false}
            value={state.brandID && state.minCost ? toMoney(state.minCost) : ""}
            label="حداقل قیمت (تومان)"
            size="small"
            variant="outlined"
            onChange={(evt) => {
              if (state.brandID) {
                setState({
                  ...state,
                  minCost: removeComma(evt.target.value),
                });
              }
            }}
            InputLabelProps={{
              shrink: true,
            }}
          />
          <TextField
            disabled={!state.brandID ? true : false}
            sx={{
              width: isSmall ? "40%" : "25%",
              input: {
                textAlign: "center",
              },
            }}
            value={state.brandID && state.maxCost ? toMoney(state.maxCost) : ""}
            label="حداکثر قیمت (تومان)"
            size="small"
            variant="outlined"
            onChange={(evt) => {
              if (state.brandID) {
                setState({
                  ...state,
                  maxCost: removeComma(evt.target.value),
                });
              }
            }}
            InputLabelProps={{
              shrink: true,
            }}
          />
          <Button
            disabled={!state.brandID ? true : false}
            sx={{ mr: 2, width: "70px" }}
            variant="contained"
            onClick={() => {
              setOpenGift(true);
            }}
          >
            عملیات
          </Button>
        </Box>
      </Box>
      <Box
        sx={{ mt: 4, mb: 2, display: "flex", alignItems: "center", gap: 0.5 }}
      >
        <FiberManualRecordIcon color="secondary" fontSize="small" />
        <Typography color="secondary" variant="subtitle1">
          براساس گروه
        </Typography>
      </Box>
      <Box display="grid" gridTemplateColumns="repeat(12, 1fr)" gap={1}>
        <Box gridColumn="span 12">
          <SelectGroup
            Gift
            Offer
            selectedGroupID={state.groupID && state.groupID}
            setter={setState}
            lvl1State={state}
          ></SelectGroup>
        </Box>
        <Box
          sx={{ display: "flex", alignItems: "center", gap: 2 }}
          gridColumn={isSmall ? "span 12" : "span 8"}
        >
          <TextField
            disabled={!state.groupID ? true : false}
            sx={{
              width: isSmall ? "40%" : "25%",
              input: {
                textAlign: "center",
              },
            }}
            value={state.groupID && state.minCost ? toMoney(state.minCost) : ""}
            label="حداقل قیمت (تومان)"
            size="small"
            variant="outlined"
            onChange={(evt) => {
              if (state.groupID) {
                setState({
                  ...state,
                  minCost: removeComma(evt.target.value),
                });
              }
            }}
            InputLabelProps={{
              shrink: true,
            }}
          />
          <TextField
            disabled={!state.groupID ? true : false}
            sx={{
              width: isSmall ? "40%" : "25%",
              input: {
                textAlign: "center",
              },
            }}
            value={state.groupID && state.maxCost ? toMoney(state.maxCost) : ""}
            label="حداکثر قیمت (تومان)"
            size="small"
            variant="outlined"
            onChange={(evt) => {
              if (state.groupID) {
                setState({
                  ...state,
                  maxCost: removeComma(evt.target.value),
                });
              }
            }}
            InputLabelProps={{
              shrink: true,
            }}
          />
          <Button
            disabled={!state.groupID ? true : false}
            sx={{ mr: 2, width: "70px" }}
            variant="contained"
            onClick={() => {
              setOpenGift(true);
            }}
          >
            عملیات
          </Button>
        </Box>
      </Box>
    </Box>
  );
}
